<div class="ui-component" [ngClass]="component | componentClasses" [class.brand-container]="isBrandContainer">



  <div class="ui-component__content container-lg"
      [ngClass]="{
        'destination-container-wtg' : brand.network == 'WTG' && destinationContainerIds.includes(component.componentConfig.id), 
        'banner-utili' : component.componentConfig.id == bannerUtiliContainerId}">

    <ng-container *ngIf="isBrandContainer">
      <ng-container *ngTemplateOutlet="brandContainer"></ng-container>
    </ng-container>
    <ng-container *ngIf="!isBrandContainer" [ngSwitch]="component.componentConfig.selector">

      <ng-container *ngSwitchCase="this.newsContainerSelector">
        <ng-container *ngIf="allNews?.length > 0">
          <ng-container *ngTemplateOutlet="news"></ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="defaultSelector"></ng-container>
      </ng-container>

    </ng-container>

  </div>
</div>

<ng-template #defaultSelector>
  <div class="ui-component__content-wrapper"
       [ngClass]="{'container-lg' : brand.network == 'WTG' && destinationContainerIds.includes(component.componentConfig.id)}">
    <div class="e-title e-title__with-divider" *ngIf="component?.content?.title || component?.content?.description">
      <h2 [innerHTML]="component?.content?.title | trustHtml"></h2>
      <h4 [innerHTML]="component?.content?.subTitle | trustHtml"></h4>
      <hr class="hr hr--heavy hr--brand hr--title mb-2">
      <p [innerHTML]="component?.content?.description | trustHtml" class="text-initial"></p>
    </div>
  </div>
  <div #childrenWrapper class="ui-component__children" *ngIf="component.children">
    <ng-container *ngTemplateOutlet="children"></ng-container>
  </div>
</ng-template>


<ng-template #news>
  <div class="ui-component__content-wrapper">
    <div class="e-title e-title__with-divider">
      <div class="news-header">
        <h2>News</h2>
        <div class="news-controls">
          <div id="previousNews" class="custom-swiper-control">
            <i class="icon-chevron-left"></i>
          </div>
          <div id="nextNews" class="custom-swiper-control">
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </div>
      <hr class="hr hr--heavy hr--brand hr--title mb-2">
    </div>
  </div>
  <div class="ui-component__children" *ngIf="allNews">
    <swiper [config]="swiperNewsConfig" class="news-previews">
      <div class="news-preview" *ngFor="let news of allNews" >
        <a class="card-wrapper" href="{{news.href}}">
          <picture>

            <button class="read-more custom-btn btn btn--brand-color-03">Visualizza</button>
            <img loading="lazy" src="{{news.image}}" alt="" />
          </picture>
          <h4>
            {{news.title}}
          </h4>
        </a>
      </div>
    </swiper>
    <div class="read-all-wrapper">
      <a (click)="goToNews()" class="read-all custom-btn btn btn--brand-color-03">Leggi tutte le news</a>
    </div>

  </div>
</ng-template>

<ng-template #brandContainer>
  <div class="ui-component__content-wrapper">
    <div class="e-title" *ngIf="component?.content?.title || component?.content?.description">
      <h2 [innerHTML]="component?.content?.title | trustHtml"></h2>
      <h4 [innerHTML]="component?.content?.subTitle | trustHtml"></h4>
      <hr class="hr hr--heavy hr--brand hr--title mb-2">
      <p [innerHTML]="component?.content?.description | trustHtml" class="text-initial"></p>
    </div>
  </div>
  <div #childrenWrapper class="ui-component__children" *ngIf="component.children">
    <ng-container *ngTemplateOutlet="children"></ng-container>
  </div>

</ng-template>

<ng-template #children>
  <ng-content></ng-content>
</ng-template>
